import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/license.query.gql"
import type {
  LicenseQuery,
  LicenseQueryVariables,
} from "@/v2-backoffice-client/license/__types__/license.query"

type Options = QueryHookOptions<LicenseQuery, LicenseQueryVariables>

export function useLicenseQuery(options?: Options) {
  return useQuery<LicenseQuery, LicenseQueryVariables>(query, options)
}
